import * as React from 'react';
import { Modal } from '../Modal';
import * as headerNav from './headerWithNav.module.scss';

const logoVariants = (logo) => {
  if (logo === "violet") {
    return "https://fs.advance.ru/landing-pages/icons/advance-logo/logo_2021.svg"
  } else if (logo === "white") {
    return "https://fs.advance.ru/landing-pages/icons/advance-logo/advance_new_logo.svg";
  } else if (logo === "orange") {
    return "https://advance.ru/03_components/header/05_imgs/logo_2021_white_orange.svg";
  } else {
    return "https://fs.advance.ru/landing-pages/icons/advance-logo/logo_2021.svg"
  }
}

export const HeaderWithNav = (
  {
    logo="violet",
    phoneColor = "#282019",
    phoneHide=false,
    data,
    buttonText,
    modal,
    widget,
    anchor="#user-action",
    padding="30px 0",
    noContainer=false,
    isFixed=true,
    noLink=false
  }
) => {
  const [isModal] = React.useState(modal);
  const [showModal, setShowModal] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 1) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    })
  }

  React.useEffect(() => {
    const burgerBtn = document.getElementById('burger');

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      burgerBtn.setAttribute('aria-expanded', true);
      burgerBtn.setAttribute('aria-label', 'Закрыть меню навигации');
    } else {
      document.body.removeAttribute('style');
      burgerBtn.setAttribute('aria-expanded', false);
      burgerBtn.setAttribute('aria-label', 'Открыть меню навигации');
    }
  }, [isOpen]);

  return (
    <header
      className={headerNav.headerNav}
      style={{position: isScrolled && isFixed ? "fixed" : "unset", backgroundColor: isScrolled && isFixed ? "#fff" : "transparent"}}>
      <div className={noContainer && !isScrolled ? null : 'container'}>
        <div className={headerNav.headerNav__wrapper} style={{ padding: padding }}>
          <div className={headerNav.headerNav__left}>
            <button
              className={`${isOpen ? `${headerNav.burger} ${headerNav.burgerIsOpened}` : `${headerNav.burger}`}`}
              id={'burger'}
              type={'button'}
              aria-label={'Открыть меню навигации'}
              onClick={() => {
                setIsOpen((prevState) => !prevState);
              }}
            >
              <span className={headerNav.burgerLine}></span>
            </button>

            {
              noLink ?
                <img
                  className={headerNav.headerNav__logoImg}
                  src={logoVariants(logo)}
                  alt={'Логотип Advance Club'}
                />
                :
                <a className={headerNav.headerNav__logo} href={'/'} target={'_blank'} rel={'noreferrer'}>
                  <img
                    className={headerNav.headerNav__logoImg}
                    src={logoVariants(logo)}
                    alt={'Логотип Advance Club'}
                  />
                </a>
            }
          </div>

          <nav
            className={`${
              isOpen
                ? `${headerNav.headerNav__nav} ${headerNav.headerNav__navIsOpened}`
                : `${headerNav.headerNav__nav} ${headerNav.headerNav__navIsClosed}`
            }`}
          >
            <ul className={headerNav.headerNav__list}>
              {data.map((elem, index) => (
                <li className={headerNav.headerNav__listItem} key={index}>
                  <a
                    className={headerNav.headerNav__listLink}
                    href={elem.href}
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  >
                    {elem.text}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {
            !phoneHide &&
            <a className={headerNav.headerNav__tel} href={'tel:88007005342'} style={{color: phoneColor}}>
              8&nbsp;(800)&nbsp;700-53-42
            </a>
          }

          {buttonText && isModal ?
            <button
              className={headerNav.headerNav__btn}
              onClick={() => {
                setShowModal(true);
              }}
            >
              {buttonText}
            </button>
            : buttonText && !isModal ?
            <a className={headerNav.headerNav__btn} href={anchor}>
              {buttonText}
            </a>
            :
            null
          }
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </header>
  );
};
